import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {getEnabledIntegrations} from '../../../../store/data/dataSelectors';
import {getRequestedIntegrations} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {IntegrationEnabledBanners} from './integrationEnabledBanners';

/*
 * Redux.
 */

const getEnabledRequestedIntegrations = createSelector(
  [getRequestedIntegrations, getEnabledIntegrations],
  (requestedIntegrations, enabledIntegrations) =>
    _(requestedIntegrations)
      .map((r) => enabledIntegrations.find((i) => i.type === r))
      .compact()
      .value(),
);

const mapStateToProps = makeMapStateToProps()(() => ({
  integrations: getEnabledRequestedIntegrations,
}));

export const IntegrationEnabledBannersContainer = connect(mapStateToProps)(IntegrationEnabledBanners);
